export default __webpack_public_path__ + "static/media/bg_1.1e409a86.png";